import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CadastrarAparelho from '../../components/Ortodontia/CadastrarAparelho'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarAparelho)
